import { GridValueFormatterParams } from '@mui/x-data-grid';
import dayjs from 'dayjs';

export default ({ value }: GridValueFormatterParams) => value && dayjs(value).format('DD.MM.YYYY HH:mm:ss');
